import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import classNames from 'classnames'
import LazyLoadImage from 'components/LazyLoadImage'

const BlogCard = ({
  id,
  date,
  title,
  shortDescription,
  image,
  thumbnail,
  imageTag,
  popular,
  link,
}) => {
  // console.log(popular)
  const cardBody = popular ? (
    <Link to={`/blogs/${id}`}>
      <h5 className="card-title">{title}</h5>
      <p className="card-text">{shortDescription}</p>
    </Link>
  ) : (
    <>
    <div className="blog-title-wrapper">
      <h5 className={`${id ? "card-title blog-id-title" : "card-title  blog-cards-title"}`}>{title}</h5>
      </div>
      <p className="card-text blog-cards-description">{shortDescription}</p>
      <div className="btn-wrapper">
        {link && (
          <Link to={`/blogs/${id}`} className="btn small-btn">
            Read More <i className="fas fa-arrow-right" />
          </Link>
        )}
      </div>
    </>
  )

  const imgBody = popular ? (
    // <Link to={`/blogs/${id}`}>
    <Link to={`/blogs/${id}`} className={classNames('card-image', 'popular-card-image')} id={`${window.location.pathname!=="/blogs" && window.location.pathname.includes("/blogs") ? "blogsIdImage" : "blogsIndImage"}`}>
      <LazyLoadImage overlaySrc={`${process.env.REACT_APP_BASE_URL}/${thumbnail}`} src={`${process.env.REACT_APP_BASE_URL}${image}`} className="card-img-top" alt={imageTag} />
      <span className="date-wrapper">{date}</span>
    </Link>
  ) : (
    // </Link>
    <div className={classNames('card-image')}>
      <LazyLoadImage overlaySrc={`${process.env.REACT_APP_BASE_URL}/${thumbnail}`} src={`${process.env.REACT_APP_BASE_URL}/${image}`} className="card-img-top" alt={imageTag} />
      <span className="date-wrapper">{date}</span>
    </div>
  )
  return (
    <div
    id={`${window.location.pathname!=="/blogs" && window.location.pathname.includes("/blogs") ? "blogsIdCard" : "blogsIndCard"}`}
      className={classNames('card', 'text-left', 'news-events-card',"blogs-ind-card", {
        'popular-news-events-card': popular,
      })}
    >
      {imgBody}
      <div className={classNames('card-body', { 'popular-card-body': popular })}>{cardBody}</div>
    </div>
  )
}

BlogCard.propTypes = {
  id: PropTypes.string.isRequired,
  date: PropTypes.string,
  title: PropTypes.string,
  shortDescription: PropTypes.string,
  image: PropTypes.string,
  popular: PropTypes.bool,
  imageTag: PropTypes.string,
  thumbnail: PropTypes.string,
  link: PropTypes.bool,
}

BlogCard.defaultProps = {
  date: '18 Jun 2019',
  title: 'Baby Care',
  imageTag: '',
  shortDescription: 'Lorem ipsum dolor sit amet, cose ctetur adipiscing elit, Quis ipsum',
  image: '/resources/img/sabinehospital-news-events/sabinehospital-news-events-01.jpg',
  popular: false,
  link: true,
  thumbnail: '',
}

export default BlogCard
